import { render } from "./sales.vue?vue&type=template&id=c5a3fe9c"
import script from "./sales.vue?vue&type=script&lang=js"
export * from "./sales.vue?vue&type=script&lang=js"

import "./sales.vue?vue&type=style&index=0&id=c5a3fe9c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__